import { PERMISSION } from '../utils/constants';
import axiosClient from './axiosClient';

export const auditLogApi = {
  getAuditLogFilterOptions: (roleId) => {
    const url = '/admin/filter/audit-logs';
    return axiosClient.get(url, {
      headers: {
        role: roleId,
      },
    });
  },

  getAuditLogs: (body, roleId) => {
    const url = `/admin/audit-logs`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  getUserActivityLogs: (body, roleId) => {
    const url = `/admin/user-activity-log`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  getAuditLogFilterByEmail: (email, roleId) => {
    const url = `/admin/filter/by-email?email=${email}`;
    return axiosClient.get(url, {
      headers: {
        role: roleId,
      },
    });
  },

  getAuditLogFilterByUserLogEmail: (email, roleId) => {
    const url = `/admin/get-by-email/user-activity-log?email=${email}`;
    return axiosClient.get(url, {
      headers: {
        role: roleId,
      },
    });
  },

  getAiPipelineRun: (body, roleActive) => {
    const url = `/admin/audit-logs/ai-pipeline-run-model`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleActive.roleId,
        permission: PERMISSION.AUDIT_LOG_AI_PIPELINE,
      },
    });
  },

  getDataPipelineRun: (body, roleId) => {
    const url = `/admin/audit-logs/data-pipeline-run`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
        permission: PERMISSION.AUDIT_LOG_AI_PIPELINE,
      },
    });
  },

  getFilterDataPipelineRun: () => {
    const url = `/admin/audit-logs/filter/data-pipeline-run`;
    return axiosClient.get(url, {
      headers: {
        permission: PERMISSION.AUDIT_LOG_AI_PIPELINE,
      },
    });
  },

  getFilterAiPipelineRun: () => {
    const url = `/admin/audit-logs/filter/ai-pipeline-run-model`;
    return axiosClient.get(url, {
      headers: {
        permission: PERMISSION.AUDIT_LOG_AI_PIPELINE,
      },
    });
  },
};
